module.exports = __webpack_public_path__ + "static/favicon-50eafcbb9aa1a2e2d34d9c2d2e648b99.ico";